import { Loader } from 'lucide-react'
import { useEffect } from 'react'

type Props = {
  tag?: string
}

export const LoadingPage: React.FC<Props> = ({ tag }: Props) => {
  useEffect(() => {
    if (window.isDevMode && tag) {
      console.log(`LoadingPage: tag ${tag}`)
    }
  }, [tag])

  return (
    <div
      className="flex flex-col h-screen justify-center items-center bg-gradient-to-b from-blue-50 to-white p-4"
      style={{
        scrollbarWidth: 'none'
      }}
    >
      <Loader className="mr-2 size-4 animate-spin" />
    </div>
  )
}
